import request from '@/utils/httpRequest'
/*
 * @author: xz
 * @date: 2021/05/01
 * */
/*
 * @Description: 票务预订列表
 * */
export function getTicketList (query) {
  return request({
    url: '/api/onlinevenues/web/ticket/page',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/ticket/index.js